import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ExpepharmaConfirmationService } from '@expepharma/services/confirmation/confirmation.service';
import { ExpepharmaConfirmationDialogComponent } from '@expepharma/services/confirmation/dialog/dialog.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [ExpepharmaConfirmationDialogComponent],
    imports: [MatButtonModule, MatDialogModule, MatIconModule, CommonModule],
    providers: [ExpepharmaConfirmationService],
})
export class ExpepharmaConfirmationModule {
    /**
     * Constructor
     */
    constructor(
        private _expepharmaConfirmationService: ExpepharmaConfirmationService
    ) {}
}
